import { computed, ref } from 'vue'
import { defineStore } from 'pinia'

export const useManufacturersStore = defineStore('manufacturers', () => {
  const manufacturers = ref([])
  const manufacturersLoaded = ref(false)

  function updateManufacturers(payload) {
    manufacturers.value = Array.isArray(payload) ? payload : []
    manufacturersLoaded.value = true
  }

  const manufacturersById = computed(() => {
    const map = {}
    for (const m of manufacturers.value) {
      map[m.objId] = m
    }
    return map
  })

  function getManufacturerById(id) {
    return manufacturersById.value[id]
  }

  function getManufacturersByIdList(idList) {
    return (Array.isArray(idList) ? idList : []).map((item) => manufacturersById.value[item.objId]).filter(Boolean)
  }

  function filterGamesWithManufacturer(games) {
    if (!Array.isArray(games)) {
      return []
    }

    if (!manufacturersLoaded.value) {
      return games
    }

    const manufacturerMap = manufacturersById.value

    return games.filter((game) => manufacturerMap[game?.manufacturerId])
  }

  return {
    // refs
    manufacturers,
    // computed

    //functions
    updateManufacturers,
    getManufacturerById,
    getManufacturersByIdList,
    filterGamesWithManufacturer,
  }
})
